/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateAdditionalQuestionDataSubtypeSchema = z.union([z.literal('multiple'), z.literal(null)])

export type UpdateAdditionalQuestionDataSubtypeSchema = z.infer<typeof updateAdditionalQuestionDataSubtypeSchema>
